function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var VideoOverlay = function VideoOverlay(_ref) {
  var id = _ref.id,
    active = _ref.active,
    title = _ref.title,
    body = _ref.body,
    link = _ref.link,
    url = _ref.url,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var _useState = useState('random'),
    _useState2 = _slicedToArray(_useState, 1),
    uuid = _useState2[0];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    t1 = _useState4[0],
    setT1 = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    t3 = _useState6[0],
    setT3 = _useState6[1];
  useEffect(function () {
    if (active === id) $("#overlay".concat(id)).css({
      opacity: 1
    });
    setTimeout(function () {
      _animate('1');
      _animate('3');
    }, 500);
    return function () {
      if (t1) clearTimeout(t1);
      if (t3) clearTimeout(t3);
    };
  }, []);
  useEffect(function () {
    if (active === id) $("#overlay".concat(id)).css({
      opacity: 1,
      right: 151
    });else {
      $("#overlay".concat(id)).css({
        opacity: 0
      });
      setTimeout(function () {
        $("#overlay".concat(id)).css({
          right: -500
        });
      }, 500);
    }
  }, [active]);
  var _animate = function animate(nr) {
    var time = Math.floor(Math.random() * 2) + 2;
    if (nr === '1') {
      if (t1) clearTimeout(t1);
      setT1(setTimeout(function () {
        _animate('1');
      }, time * 1000));
    } else if (nr === '3') {
      if (t3) clearTimeout(t3);
      setT3(setTimeout(function () {
        _animate('3');
      }, time * 1000));
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay",
    id: "overlay".concat(id),
    style: _objectSpread(_objectSpread({}, style), {}, {
      right: -500,
      bottom: 346
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay__content--txt"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay__content--title",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay__content--body"
  }, body), /*#__PURE__*/React.createElement("div", {
    className: ['vid-overlay__content--link', url ? 'vid-overlay__content--active' : ''].join(' '),
    onClick: function onClick() {
      if (url && url.includes('//')) window.open(url, '_blank');else if (url) {}
    }
  }, link))), /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay__backdrop vid-overlay__backdrop--1",
    id: "".concat(uuid, "1")
  }), /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay__backdrop vid-overlay__backdrop--2",
    id: "".concat(uuid, "2")
  }), /*#__PURE__*/React.createElement("div", {
    className: "vid-overlay__backdrop vid-overlay__backdrop--3",
    id: "".concat(uuid, "3")
  }));
};
export default VideoOverlay;